<template>
    <v-overlay :value="value" @input="$emit('input', $event)">
        <v-sheet color="white" class="pa-4" width="300" elevation="1" rounded>
            <v-progress-linear indeterminate color="primary"/>
            <div class="primary--text text-center mt-2">Please Wait ...</div>
        </v-sheet>
    </v-overlay>
</template>

<script>
export default {
    name: "LoadingOverlay",
    props: {
        value: Boolean
    }
}
</script>

<style>

</style>